import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import sidebarReducer from "redux/slices/sidebarSlice";
import gatewayReducer from "redux/slices/gatewaySlice";
import modalReducer from "redux/slices/modalSlice";
import autoLogoutReducer from "redux/slices/autoLogoutSlice";
import authReducer from "redux/slices/authSlice";
import logoutReducer from "redux/slices/logoutSlice";

const appReducer = combineReducers({
  sidebar: sidebarReducer,
  gateway: gatewayReducer,
  modal: modalReducer,
  autoLogout: autoLogoutReducer,
  auth: authReducer,
  logout: logoutReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_APP") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// 🔹 STEP 3: Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["gateway"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
